import React from 'react'

var emptyImageLight = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMnSURBVHgB7dYBEYAwEMCwBzHzb2czM/DRRESvz977DllrraHrHSBLACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACDsub8h65wzdDkACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACPsAGA4MhUaQUtgAAAAASUVORK5CYII="
var emptyImageDark = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMqSURBVHgB7dZBEYAwEMDAg3e1VED9K6ghEJJdEZk855xvyLr3Dl3vAFkCAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGECAGHPWusbsvbeQ5cDgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgDABgLAfUQsHzwUPBscAAAAASUVORK5CYII="

import CBInstitutionPreview from "./CBInstitutionPreview.tsx"
import { CBCollegeListPreview } from './CBCollegeListPreview.tsx'
import CBMessageFeedPreview from './CBMessageFeedPreview.js'
import CBMessagePreview from './CBMessagePreview.js'

function getAssetSrc(assets, ids) {
    let items = {}
    ids.forEach(id => {
        let a = assets[id]
        if (a) {
            items[id] = a.src
        } else {
            items[id] = emptyImageLight
        }
    })
    return items
}

const previewCallback = (id) =>     {
    const assetSrc = (assetid) => {
        return catalogAssets[assetid] ? catalogAssets[assetid].src : null
    }

    switch (id) {
        /** 
         * Preview - College Profile Screen 
         */
        case 'institution-profile':
            return <CBInstitutionPreview title="Some University"
                                         subtitle="Someplace, Somewhere"
                                         background={assetSrc('header')}
                                         logo={assetSrc('logo-avatar')}/>

        /** 
         * Preview - Saved Screen
         */
        case 'saved':
            // College Tiles
            let tiles = [
                {
                    'title'      : 'University Title',
                    'logo'       : assetSrc('logo-avatar'),
                    'background' : assetSrc('header')
                },
                { 
                    'title' : 'Other University' 
                }
            ]

            // Empty Messages
            let listItems = [
                { 'title' : ''  },
                { 'title' : '' },
            ]

            return <CBSavedListPreview  tileItems={tiles}
                                        listItems={listItems}/>

        /** 
         * Preview - Message
         */
        case 'message':
            return <CBMessagePreview 
                        title={"Message Title"} 
                        caption={"TUE 13 JUN, 6:21 PM"}
                        institutionTitle={"UVA"}
                        institutionLocation={"Someplace, Somewhere"}
                        institutionLogo={assetSrc('logo-avatar')}
                        message={"This is a message!"}/>

        /** 
         * Preview - Messages Feed
         */
        case 'message-feed':
        case 'message-feed-dark':
            let messageItems = [
                {
                    'type'  : 'message-card',
                    'title' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
                    'logo'  : assetSrc('logo-wordmark-light')
                },
                {   'title' : '' },
                {   'title' : '' },
                {   'title' : '' }               
            ]

            return <CBMessageFeedPreview 
                        width={1000}
                        dark={id == "message-feed-dark"}
                        title={"Messages"} 
                        messages={messageItems}/>
    }
    return null
}

var CollegeboardAssetPreviewLibrary = { }
CollegeboardAssetPreviewLibrary._previewCallback = previewCallback

// 
// Previews
//
const avatarPreviews = function (previewAssets) {
    return [

        {
            'title': 'College Profile Page',
            'contentPreview' : () => {
                let assets = getAssetSrc(previewAssets, ['header', 'logo-avatar'])
                return CollegeboardAssetPreviewLibrary._previewCallback('institution-profile', 'logo-avatar', assets)
            },
            'highlightLayer' : { x: 149, y: 365, width: 90, height: 90, cornerRadius: 18, border: '1', borderColor: '#e3e3e3', src: emptyImageLight, id: 'logo-avatar' },
        },

        {
            'title': 'College Message',
            'contentPreview' : () => {
                let assets = getAssetSrc(previewAssets, ['logo-avatar'])
                return CollegeboardAssetPreviewLibrary._previewCallback('message', 'logo-avatar', assets)
            },
        },

        {
            'title': 'College Tile',
            'contentPreview' : () => {
                let assets = getAssetSrc(previewAssets, ['header', 'logo-avatar'])
                return CollegeboardAssetPreviewLibrary._previewCallback('saved', 'logo-avatar', assets)
            }
        },

        {
            'title': 'Message Feed',
            'contentPreview' : () => {
                let assets = getAssetSrc(previewAssets, ['header', 'logo-avatar', 'logo'])
                return CollegeboardAssetPreviewLibrary._previewCallback('message-feed', 'logo-avatar', assets)
            }
        },

    ]
}

const wordmarkPreviewsLight = function (previewAssets) {
    return [{
        'title': 'Messages - Light',
        'contentPreview' : () => {
            let assets = getAssetSrc(previewAssets, ['workmark-logo-light'])
            return CollegeboardAssetPreviewLibrary._previewCallback('message-feed', 'wordmark-logo-light', assets)
        },
        'highlightLayer': { x: 40, y: 190, placeholderWidth: 150, placeholderHeight: 26, variableWidth: true, maxHeight: 26, maxWidth: 150, id: 'logo-wordmark-light' },
        
    }]
}

const wordmarkPreviewsDark = function (previewAssets) {
    return [{
        'title': 'Messages - Dark',
        'contentPreview' : () => {
            let assets = getAssetSrc(previewAssets, ['workmark-logo-dark'])
            return CollegeboardAssetPreviewLibrary._previewCallback('message-feed-dark', 'wordmark-logo-dark', assets)
        },
        
        'highlightLayer': { x: 40, y: 190, placeholderWidth: 150, placeholderHeight: 26, variableWidth: true, maxHeight: 26, maxWidth: 150, id: 'logo-wordmark-light' },
    }]
}

const headerPreview = function (previewAssets) {
    return [
        
        {
            'title': 'College Profile Page',
            'contentPreview' : () => {
                let assets = getAssetSrc(previewAssets, ['logo-avatar', 'header'])
                return CollegeboardAssetPreviewLibrary._previewCallback('institution-profile', 'header', assets)
            },
            'highlightLayer' : { x: 0, y: 0, width: 390, height: 415, id: 'header' },
        },

        {
            'title': 'College List',
            'contentPreview' : () => {
                let assets = getAssetSrc(previewAssets, ['logo-avatar', 'header'])
                return CollegeboardAssetPreviewLibrary._previewCallback('saved',  'header',  assets)
            }
        }
    ]

}

//
// Example Preivews

const exampleAvatarPreviews = function (assets) {
    return [
        {
            'title': 'College Profile Page',
            'background': 'preview-college-detail.png',
            'layers': [
                { x: 0, y: 0, width: 390, height: 397, asset: assets['header'], src: emptyImageLight, id: 'header' },
                { x: 149, y: 348, width: 92, height: 92, cornerRadius: 18, src: emptyImageLight },
                { x: 150, y: 349, width: 90, height: 90, cornerRadius: 18, border: '1', borderColor: '#e3e3e3', asset: {src: 'example-logo-avatar.png' }, id: 'logo-avatar' }
            ],
        },

        {
            'title': 'College Tile',
            'background': 'preview-saved.png',
            'layers': [
                { x: 19, y: 215, width: 167, height: 127, cornerRadius: 11, asset: assets['header'], src: emptyImageLight },
                { x: 31, y: 280, width: 49, height: 49, cornerRadius: 11, asset: {src: 'example-logo-avatar.png' }, src: emptyImageLight },
            ]
        },

        {
            'title': 'College Profile Page',
            'background': 'preview-college-detail.png',
            'layers': [
                { x: 0, y: 0, width: 390, height: 397, asset: assets['header'], src: emptyImageLight, id: 'header' },
                { x: 149, y: 348, width: 92, height: 92, cornerRadius: 18, src: emptyImageLight },
                { x: 150, y: 349, width: 90, height: 90, cornerRadius: 18, border: '1', borderColor: '#e3e3e3', asset: {src: 'example-logo-avatar-bg.png' }, id: 'logo-avatar' }
            ],
        },

    ]
}


const exampleAvatarPreviewsBad = function (assets) {
    return [
        {
            'title': 'College Profile Page',
            'background': 'preview-college-detail.png',
            'layers': [
                { x: 0, y: 0, width: 390, height: 397, asset: assets['header'], src: emptyImageLight, id: 'header' },
                { x: 149, y: 348, width: 92, height: 92, cornerRadius: 18, src: emptyImageLight },
                { x: 150, y: 349, width: 90, height: 90, cornerRadius: 18, border: '1', borderColor: '#e3e3e3', asset: {src: 'example-logo-avatar-bad.png' }, id: 'logo-avatar' }
            ],
        },
        {
            'title': 'College Profile Page',
            'background': 'preview-college-detail.png',
            'layers': [
                { x: 0, y: 0, width: 390, height: 397, asset: assets['header'], src: emptyImageLight, id: 'header' },
                { x: 149, y: 348, width: 92, height: 92, cornerRadius: 18, src: emptyImageLight },
                { x: 150, y: 349, width: 90, height: 90, cornerRadius: 18, border: '1', borderColor: '#e3e3e3', asset: {src: 'example-logo-avatar-bad2.png' }, id: 'logo-avatar' }
            ],
        },
    ]
}



const allPreviews = [avatarPreviews, wordmarkPreviewsLight, wordmarkPreviewsDark]
const allExamplePreviews = [ exampleAvatarPreviews, exampleAvatarPreviewsBad ]

export { avatarPreviews, wordmarkPreviewsLight, wordmarkPreviewsDark, headerPreview, allPreviews, exampleAvatarPreviews, exampleAvatarPreviewsBad, allExamplePreviews, CollegeboardAssetPreviewLibrary }